import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

import { IWarranty } from '@seb/web-design-system/core';

@Injectable({
  providedIn: 'root'
})
export class ExtendedWarrantyMapper {
  constructor(
    private translateService: TranslateService
  ) {}

  toWarranty(offer, locale, index, currencies, category, entryNumber): IWarranty {
    const itemsList = [];
    locale.coverage[offer.coverage_id].items.map((item) => itemsList.push(item));
    itemsList.unshift(
      this.translateService.instant('addToCart.extendedWarranty.years.warranty',
        { years: Number(offer.term) / 12 })
    );
    const currency = currencies.filter((currency) => currency.isocode === offer.currency)[0];
    const formattedOfferPrice = offer.price.toString().replaceAll('.', ',');
    return {
      id: offer.id,
      labelTitle: locale.coverage[offer.coverage_id].title,
      state: false,
      nameField: locale.coverage[offer.coverage_id].title,
      list: itemsList,
      price: currency ? formattedOfferPrice + ' ' + currency.symbol : formattedOfferPrice + ' ' + offer.currency,
      priceValue: Number(offer.price),
      duration: 'Duration ' + index,
      category,
      entryNumber
    };
  }
}
